export default {
  twoFactorAuthTitle: {
    id: 'app.containers.MFA.twoFactorAuthTitle',
    defaultMessage: 'Two-Factor Authentication',
  },
  setupTitle: {
    id: 'app.containers.MFA.setup.title',
    defaultMessage: 'Set up Two-Factor Authentication',
  },
  verifyTitle: {
    id: 'app.containers.MFA.verify.title',
    defaultMessage: 'Verify Your Device',
  },

  setupInstructions: {
    id: 'app.containers.MFA.setup.instructions',
    defaultMessage:
      'Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)',
  },
  manualEntryLabel: {
    id: 'app.containers.MFA.setup.manualEntry',
    defaultMessage: 'Or enter this code manually:',
  },
  verifyInstructions: {
    id: 'app.containers.MFA.verify.instructions',
    defaultMessage: 'Enter the 6-digit code from your authenticator app',
  },

  codeLabel: {
    id: 'app.containers.MFA.form.codeLabel',
    defaultMessage: 'Authentication Code',
  },
  codePlaceholder: {
    id: 'app.containers.MFA.form.codePlaceholder',
    defaultMessage: '000000',
  },

  backupCodesTitle: {
    id: 'app.containers.MFA.backup.title',
    defaultMessage: 'Backup Codes',
  },
  backupCodesDescription: {
    id: 'app.containers.MFA.backup.description',
    defaultMessage:
      'Save these backup codes in a secure place. Each code can be used once to sign in if you lose access to your authenticator app.',
  },
  backupCodesRemaining: {
    id: 'app.containers.MFA.backup.remaining',
    defaultMessage: '{count} backup codes remaining',
  },

  setupButton: {
    id: 'app.containers.MFA.button.setup',
    defaultMessage: 'Set Up Two-Factor Authentication',
  },
  verifyButton: {
    id: 'app.containers.MFA.button.verify',
    defaultMessage: 'Verify',
  },
  disableButton: {
    id: 'app.containers.MFA.button.disable',
    defaultMessage: 'Disable Two-Factor Authentication',
  },
  regenerateCodesButton: {
    id: 'app.containers.MFA.button.regenerateCodes',
    defaultMessage: 'Regenerate Backup Codes',
  },
  downloadCodesButton: {
    id: 'app.containers.MFA.button.downloadCodes',
    defaultMessage: 'Download Codes',
  },
  copyCodesButton: {
    id: 'app.containers.MFA.button.copyCodes',
    defaultMessage: 'Copy Codes',
  },
  continueButton: {
    id: 'app.containers.MFA.button.continue',
    defaultMessage: 'Continue',
  },
  cancelButton: {
    id: 'app.containers.MFA.button.cancel',
    defaultMessage: 'Cancel',
  },

  mfaEnabled: {
    id: 'app.containers.MFA.status.enabled',
    defaultMessage: 'Enabled',
  },
  mfaDisabled: {
    id: 'app.containers.MFA.status.disabled',
    defaultMessage: 'Disabled',
  },

  disableConfirmTitle: {
    id: 'app.containers.MFA.disable.confirmTitle',
    defaultMessage: 'Disable Two-Factor Authentication?',
  },
  disableConfirmMessage: {
    id: 'app.containers.MFA.disable.confirmMessage',
    defaultMessage:
      'Are you sure you want to disable two-factor authentication? This will make your account less secure.',
  },
  disableRequireCode: {
    id: 'app.containers.MFA.disable.requireCode',
    defaultMessage:
      'Enter your authentication code to disable two-factor authentication',
  },
  disablePasswordLabel: {
    id: 'app.containers.MFA.disable.passwordLabel',
    defaultMessage: 'Password',
  },
  disablePasswordPlaceholder: {
    id: 'app.containers.MFA.disable.passwordPlaceholder',
    defaultMessage: 'Enter your password',
  },

  challengeTitle: {
    id: 'app.containers.MFA.challenge.title',
    defaultMessage: 'Two-Factor Authentication',
  },
  challengeDescription: {
    id: 'app.containers.MFA.challenge.description',
    defaultMessage:
      'Enter the 6-digit code from your authenticator app or use a backup code',
  },
  useBackupCode: {
    id: 'app.containers.MFA.challenge.useBackupCode',
    defaultMessage: 'Use a backup code instead',
  },
  useAuthenticatorApp: {
    id: 'app.containers.MFA.challenge.useAuthenticatorApp',
    defaultMessage: 'Use authenticator app',
  },

  cantScanImage: {
    id: 'app.containers.MFA.setup.cantScanImage',
    defaultMessage: "Can't scan image?",
  },
  secretKeyCopied: {
    id: 'app.containers.MFA.setup.secretKeyCopied',
    defaultMessage: 'Secret key copied to clipboard',
  },
  copyButton: {
    id: 'app.containers.MFA.button.copy',
    defaultMessage: 'Copy',
  },
  nextButton: {
    id: 'app.containers.MFA.button.next',
    defaultMessage: 'Next',
  },
  backButton: {
    id: 'app.containers.MFA.button.back',
    defaultMessage: 'Back',
  },
  codeRequired: {
    id: 'app.containers.MFA.error.codeRequired',
    defaultMessage: 'Code is required',
  },
  codeInvalid: {
    id: 'app.containers.MFA.error.codeInvalid',
    defaultMessage: 'Invalid code format',
  },

  settingsDescriptionEnabled: {
    id: 'app.containers.MFA.settings.descriptionEnabled',
    defaultMessage:
      'Your account is protected with two-factor authentication. You will need to enter a code from your authenticator app when signing in.',
  },
  settingsDescriptionDisabled: {
    id: 'app.containers.MFA.settings.descriptionDisabled',
    defaultMessage:
      'Add an extra layer of security to your account by enabling two-factor authentication.',
  },
  regenerateCodesLink: {
    id: 'app.containers.MFA.settings.regenerateCodesLink',
    defaultMessage: 'Regenerate codes',
  },

  enterBackupCodePlaceholder: {
    id: 'app.containers.MFA.challenge.enterBackupCodePlaceholder',
    defaultMessage: 'Enter backup code',
  },
  trustDeviceLabel: {
    id: 'app.containers.MFA.challenge.trustDeviceLabel',
    defaultMessage: 'Trust this device for 30 days',
  },

  trustedDevicesTitle: {
    id: 'app.containers.MFA.trustedDevices.title',
    defaultMessage: 'Trusted Devices',
  },
  trustedDevicesDescription: {
    id: 'app.containers.MFA.trustedDevices.description',
    defaultMessage: "Devices that won't require MFA verification",
  },
  trustedDevicesEmpty: {
    id: 'app.containers.MFA.trustedDevices.empty',
    defaultMessage:
      'No trusted devices. When you check "Trust this device" during login, it will appear here.',
  },
  trustedDevicesLastUsed: {
    id: 'app.containers.MFA.trustedDevices.lastUsed',
    defaultMessage: 'Last used {time}',
  },
  trustedDevicesExpires: {
    id: 'app.containers.MFA.trustedDevices.expires',
    defaultMessage: 'Expires {time}',
  },
  trustedDevicesRevoke: {
    id: 'app.containers.MFA.trustedDevices.revoke',
    defaultMessage: 'Revoke',
  },
  trustedDevicesRevokeAll: {
    id: 'app.containers.MFA.trustedDevices.revokeAll',
    defaultMessage: 'Revoke All Devices',
  },
  trustedDevicesRevoked: {
    id: 'app.containers.MFA.trustedDevices.revoked',
    defaultMessage: 'Device revoked successfully',
  },
  trustedDevicesAllRevoked: {
    id: 'app.containers.MFA.trustedDevices.allRevoked',
    defaultMessage: 'All trusted devices have been revoked',
  },
  trustedDevicesRevokeError: {
    id: 'app.containers.MFA.trustedDevices.revokeError',
    defaultMessage: 'Failed to revoke device. Please try again.',
  },
  trustedDevicesLoadError: {
    id: 'app.containers.MFA.trustedDevices.loadError',
    defaultMessage: 'Failed to load trusted devices',
  },
  trustedDevicesCount: {
    id: 'app.containers.MFA.trustedDevices.count',
    defaultMessage: '{count, plural, =1 {1 device} other {{count} devices}}',
  },

  deviceNameChrome: {
    id: 'app.containers.MFA.trustedDevices.deviceName.chrome',
    defaultMessage: 'Chrome Browser',
  },
  deviceNameFirefox: {
    id: 'app.containers.MFA.trustedDevices.deviceName.firefox',
    defaultMessage: 'Firefox Browser',
  },
  deviceNameSafari: {
    id: 'app.containers.MFA.trustedDevices.deviceName.safari',
    defaultMessage: 'Safari Browser',
  },
  deviceNameEdge: {
    id: 'app.containers.MFA.trustedDevices.deviceName.edge',
    defaultMessage: 'Edge Browser',
  },
  deviceNameMobile: {
    id: 'app.containers.MFA.trustedDevices.deviceName.mobile',
    defaultMessage: 'Mobile Device',
  },
  deviceNameIphone: {
    id: 'app.containers.MFA.trustedDevices.deviceName.iphone',
    defaultMessage: 'iPhone',
  },
  deviceNameAndroid: {
    id: 'app.containers.MFA.trustedDevices.deviceName.android',
    defaultMessage: 'Android Device',
  },
  deviceNameUnknown: {
    id: 'app.containers.MFA.trustedDevices.deviceName.unknown',
    defaultMessage: 'Unknown Device',
  },

  confirmSavedCodes: {
    id: 'app.containers.MFA.backup.confirmSavedCodes',
    defaultMessage: 'I have saved these backup codes in a secure location',
  },
  backupCodesCopied: {
    id: 'app.containers.MFA.backup.copied',
    defaultMessage: 'Backup codes copied to clipboard',
  },
  backupCodesCopyFailed: {
    id: 'app.containers.MFA.backup.copyFailed',
    defaultMessage: 'Failed to copy backup codes. Please try again.',
  },
  backupCodesDownloaded: {
    id: 'app.containers.MFA.backup.downloaded',
    defaultMessage: 'Backup codes downloaded',
  },
  backupCodesFileTitle: {
    id: 'app.containers.MFA.backup.fileTitle',
    defaultMessage: 'Candidately - Two-Factor Authentication Backup Codes',
  },
  backupCodesFileWarning: {
    id: 'app.containers.MFA.backup.fileWarning',
    defaultMessage:
      'IMPORTANT: Keep these codes in a secure place. Each code can only be used once.',
  },

  enforcedSetupBadge: {
    id: 'app.containers.MFA.enforcedSetup.badge',
    defaultMessage: 'Required by your company',
  },
  enforcedSetupTitle: {
    id: 'app.containers.MFA.enforcedSetup.title',
    defaultMessage: 'Two-Factor Authentication Required',
  },
  enforcedSetupDescription: {
    id: 'app.containers.MFA.enforcedSetup.description',
    defaultMessage:
      'Your company requires all team members to use two-factor authentication. Please set up your authenticator app to continue.',
  },
  enforcedSetupSignOut: {
    id: 'app.containers.MFA.enforcedSetup.signOut',
    defaultMessage: 'Sign out',
  },

  disableTitle: {
    id: 'app.containers.MFA.disable.title',
    defaultMessage: 'Disable Two-Factor Authentication',
  },
  disableDescription: {
    id: 'app.containers.MFA.disable.description',
    defaultMessage:
      'Enter your password to disable two-factor authentication. This will make your account less secure.',
  },
  disableSubmit: {
    id: 'app.containers.MFA.disable.submit',
    defaultMessage: 'Disable 2FA',
  },

  regenerateTitle: {
    id: 'app.containers.MFA.regenerate.title',
    defaultMessage: 'Regenerate Backup Codes',
  },
  regenerateDescription: {
    id: 'app.containers.MFA.regenerate.description',
    defaultMessage:
      'Enter your authentication code to generate new backup codes. Your old codes will no longer work.',
  },
  regenerateSubmit: {
    id: 'app.containers.MFA.regenerate.submit',
    defaultMessage: 'Generate New Codes',
  },

  flashSetupSuccess: {
    id: 'app.containers.MFA.flash.setupSuccess',
    defaultMessage: 'Two-factor authentication has been successfully enabled',
  },
  flashSetupError: {
    id: 'app.containers.MFA.flash.setupError',
    defaultMessage:
      'Failed to setup two-factor authentication. Please try again.',
  },
  flashDisableSuccess: {
    id: 'app.containers.MFA.flash.disableSuccess',
    defaultMessage: 'Two-factor authentication has been disabled',
  },
  flashDisableError: {
    id: 'app.containers.MFA.flash.disableError',
    defaultMessage:
      'Failed to disable two-factor authentication. Please try again.',
  },
  flashInvalidCode: {
    id: 'app.containers.MFA.flash.invalidCode',
    defaultMessage: 'Invalid authentication code. Please try again.',
  },
  flashAccountLocked: {
    id: 'app.containers.MFA.flash.accountLocked',
    defaultMessage:
      'Account temporarily locked due to too many failed attempts.',
  },
  flashBackupCodesRegenerated: {
    id: 'app.containers.MFA.flash.backupCodesRegenerated',
    defaultMessage: 'Backup codes have been regenerated successfully',
  },
  flashBackupCodeWarning: {
    id: 'app.containers.MFA.flash.backupCodeWarning',
    defaultMessage:
      'Save these backup codes in a safe place. You will not be able to see them again.',
  },
  flashPasswordRequired: {
    id: 'app.containers.MFA.flash.passwordRequired',
    defaultMessage: 'Password is required',
  },
  flashInvalidCodeFormat: {
    id: 'app.containers.MFA.flash.invalidCodeFormat',
    defaultMessage: 'Please enter a valid 6-digit code',
  },
  flashStatusFetchError: {
    id: 'app.containers.MFA.flash.statusFetchError',
    defaultMessage: 'Failed to get MFA status',
  },
  flashIncorrectPassword: {
    id: 'app.containers.MFA.flash.incorrectPassword',
    defaultMessage: 'Incorrect password',
  },
  flashDisablePasswordRequired: {
    id: 'app.containers.MFA.flash.disablePasswordRequired',
    defaultMessage: 'Password is required to disable two-factor authentication',
  },
  flashDisableEnforcementActive: {
    id: 'app.containers.MFA.flash.disableEnforcementActive',
    defaultMessage:
      'MFA cannot be disabled while company enforcement is active',
  },
  flashEnforcementEnabled: {
    id: 'app.containers.MFA.flash.enforcementEnabled',
    defaultMessage:
      'MFA enforcement has been enabled. All team members will be required to set up two-factor authentication.',
  },
  flashEnforcementDisabled: {
    id: 'app.containers.MFA.flash.enforcementDisabled',
    defaultMessage: 'MFA enforcement has been disabled.',
  },
  flashEnforcementUpdateError: {
    id: 'app.containers.MFA.flash.enforcementUpdateError',
    defaultMessage: 'Failed to update MFA enforcement setting.',
  },
  flashOwnerMfaRequired: {
    id: 'app.containers.MFA.flash.ownerMfaRequired',
    defaultMessage:
      'You must enable MFA on your own account before enforcing it for the company.',
  },
  flashRemoveUserMFASuccess: {
    id: 'app.containers.MFA.flash.removeUserMFASuccess',
    defaultMessage: 'MFA has been successfully removed for this user',
  },
  flashRemoveUserMFAError: {
    id: 'app.containers.MFA.flash.removeUserMFAError',
    defaultMessage: 'Failed to remove MFA. Please try again.',
  },

  enforcementCannotDisable: {
    id: 'app.containers.MFA.enforcement.cannotDisable',
    defaultMessage: 'MFA cannot be disabled while your company requires it',
  },
  enforcementSectionTitle: {
    id: 'app.containers.MFA.enforcement.sectionTitle',
    defaultMessage: 'Security',
  },
  enforcementFieldLabel: {
    id: 'app.containers.MFA.enforcement.fieldLabel',
    defaultMessage: 'Company MFA Enforcement',
  },
  enforcementBadgeEnforced: {
    id: 'app.containers.MFA.enforcement.badgeEnforced',
    defaultMessage: 'Enforced',
  },
  enforcementBadgeNotEnforced: {
    id: 'app.containers.MFA.enforcement.badgeNotEnforced',
    defaultMessage: 'Not enforced',
  },
  enforcementFieldDescription: {
    id: 'app.containers.MFA.enforcement.fieldDescription',
    defaultMessage:
      'Require all company members to use two-factor authentication when signing in.',
  },
  enforcementToggleLabel: {
    id: 'app.containers.MFA.enforcement.toggleLabel',
    defaultMessage: 'Require MFA for all company members',
  },
  enforcementOwnerOnly: {
    id: 'app.containers.MFA.enforcement.ownerOnly',
    defaultMessage: 'Only company owners can change this setting',
  },
  enforcementConfirmMessage: {
    id: 'app.containers.MFA.enforcement.confirmMessage',
    defaultMessage:
      '{count, plural, =0 {All team members will be required to set up MFA on their next login.} one {{count} member has not yet set up MFA and will be immediately affected by this change.} other {{count} members have not yet set up MFA and will be immediately affected by this change.}}',
  },
  enforcementConfirmEnable: {
    id: 'app.containers.MFA.enforcement.confirmEnable',
    defaultMessage: 'Enable enforcement',
  },
  enforcementStatsTitle: {
    id: 'app.containers.MFA.enforcement.statsTitle',
    defaultMessage: 'MFA adoption',
  },
  enforcementStatsLabel: {
    id: 'app.containers.MFA.enforcement.statsLabel',
    defaultMessage: '{enabled} of {total} members',
  },
  enforcementStatsDetail: {
    id: 'app.containers.MFA.enforcement.statsDetail',
    defaultMessage:
      '{count, plural, one {# member has} other {# members have}} not set up MFA',
  },
};
